import { StopOutlined } from '@ant-design/icons'
import { t } from '@lingui/macro'
import ButtonWithTooltip from 'components/molecules/buttons'
import { deactivateLink } from 'redux/administration/administration-users/AdministrationUsers.slice'
import { useAppDispatch } from 'redux/store'

interface ActionProps {
  id: number
}

const LinkCancelButton: React.FC<ActionProps> = ({ id }) => {
  const dispatch = useAppDispatch()
  return (
    <ButtonWithTooltip
      onClick={async () => {
        if (id) {
          dispatch(deactivateLink(id))
        }
      }}
      tooltipText={t({
        id: 'administration.users.buttons.invalidate_account_activation_code_text',
        message: 'Invalidate activation code',
      })}
      icon={<StopOutlined />}
      withLoading
    />
  )
}

export default LinkCancelButton
